import React, { Component } from 'react'
import FormOne from './FormOne';
import { withStyles, Fade } from '@material-ui/core';
import { PostData } from '../../api/service';
import FormTwo from './FormTwo';
import FormThree from './FormThree';
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css' // Import css

const styles = theme => ({

})

class ForgotPassword extends Component {
    constructor(props) {
        super(props);

        this.state = {
            form: 1,
            email: '',
            date_of_birth: '',
            message: '',
            otp: '',
            error_one: ''
        }


    }

    changeForm = (id) => {
        this.setState({
            form: id
        })
    }

    setEmail(email, date_of_birth) {

        const data = {
            email: email,
            phone: email,
            date_of_birth: date_of_birth
        }

        PostData('/forgotpassworda', data)
            .then((resp) => {
            
                if (resp.status !== false) {
                    this.setState({
                        email: resp.to,
                        message: resp.message,
                        form: 2,
                        otp: resp.otp
                    })
                    this.setOtp(resp.otp)
                } else {
                    this.setState({
                        error_one: resp.message
                    })
                }
            })


    }

    setOtp(otp) {
        const data = {
            otp: otp,
            email: this.state.email
        }
        PostData('/forgotpassworda/otp', data)
            .then((resp) => {
                if (resp === true) {
                    this.setState({
                        form: 3,
                        message: '',
                        otp: otp
                    })
                } else {
                    this.setState({
                        message: 'Wrong OTP! Please try again.'
                    })
                }
            })
    }


    setPassword(password) {
        const data = {
            email: this.state.email,
            password: password,
            otp: this.state.otp
        }

        PostData('/forgotpassworda/final', data)
            .then((resp) => {
                //console.log(resp)
                if (resp === true) {
                    confirmAlert({
                        title: 'Successfully Updated',
                        message: 'You will be redirected to the login page',
                        buttons: [
                            {
                                label: 'OKAY',
                                onClick: () => this.props.history.replace('/')
                            }
                        ]
                    })
                } else {
                    confirmAlert({
                        title: 'Something Went Wrong',
                        message: 'Please try again later',
                        buttons: [
                            {
                                label: 'OKAY',
                                onClick: () => this.props.history.replace('/')
                            }
                        ]
                    })
                }
            })
    }


    render() {
        switch (this.state.form) {
            case 1:
                return (
                    
                        <FormOne setEmail={this.setEmail.bind(this)} error={this.state.error_one} />
                    )

            case 2:
                return <FormTwo message={this.state.message} email={this.state.email} setOtp={this.setOtp.bind(this)} />

            case 3:
                return <FormThree setPassword={this.setPassword.bind(this)} />

            default:
                break;
        }
    }
}


export default withStyles(styles)(ForgotPassword)


// WEBPACK FOOTER //
// ./src/Components/ForgotPassword/ForgotPassword.js